/** TanStack Query hooks for prompt library. */

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/services/api";
import type { Prompt } from "@/types";

export function usePrompts() {
  return useQuery<{ personalPrompts: Prompt[]; templatePrompts: Prompt[] }>({
    queryKey: ["prompts"],
    queryFn: () => api.get("/reporting/prompts"),
  });
}

export function useCreatePrompt() {
  const qc = useQueryClient();
  return useMutation<Prompt, Error, { title: string; content: string; promptType?: string }>({
    mutationFn: (body) => api.post("/reporting/prompts", body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["prompts"] }),
  });
}

export function useUpdatePrompt() {
  const qc = useQueryClient();
  return useMutation<unknown, Error, { promptId: string; title: string; content: string }>({
    mutationFn: ({ promptId, ...body }) => api.put(`/reporting/prompts/${promptId}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["prompts"] }),
  });
}

export function useDeletePrompt() {
  const qc = useQueryClient();
  return useMutation<unknown, Error, string>({
    mutationFn: (promptId) => api.del(`/reporting/prompts/${promptId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["prompts"] }),
  });
}
